export enum ChargeType {
  INCLUSIVE = 'INCLUSIVE', // Extracted from subtotal (e.g. Catering Levy)
  EXCLUSIVE = 'EXCLUSIVE' // Added on top of subtotal (e.g. Delivery/Service Fee)
}
